import { createContext, useContext } from 'react';

import type { AlertProps } from '@/features/popup/components/Alert';
import type { ToastProps } from '@/features/popup/components/Toast';

export type PopupContextValues = {
  showToast: (toast: Omit<ToastProps, 'onClose' | 'isVisible'>) => void;
  clearAllAlerts: () => void;
  showAlert: (alert: Omit<AlertProps, 'onClose' | 'isVisible'>) => void;
};

const defaultValues: PopupContextValues = {
  showToast: () => {},
  clearAllAlerts: () => {},
  showAlert: () => {}
};

export const PopupContext = createContext<PopupContextValues>(defaultValues);
/**
 * Note: some elements wont work properly inside modals, in such cases consider using the components directly
 * - showToast is showing the toast behind the bottom sheet
 *
 * Note: if the component is used directly, it may be needed to wrap the component inside Portal (e.g. see GroupEditorScreen) and trigger the visibility by:
 * {isVisible && <Portal> <Alert isVisible={true} ... /></Portal>}
 */
export const usePopup = () => useContext(PopupContext);
